export const ANNOUNCMENT_CLOSED = 'announcmentClosed';
